<div class="loading" *ngIf="showing > 0">
    <div class="indicator alert alert-warning">
        <i class="fa fa-spinner fa-pulse"></i> {{'loading' | translate}}...
    </div>
</div>
